import React, { useEffect, useState } from "react";
import { editMenu, getMenuById } from "../Services/MenuApi";
import { Link, useParams } from "react-router-dom";
import { getCategories } from "../Services/CategrieApi";
import swal from "sweetalert";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Repeater from "./../Components/Repeater";
import { useUser } from "../Auth/useUser";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import GifLoader from "../Components/loader";
import { useOrganisations } from "../Auth/useOrganisations";
import { getOrganisationById } from "../Services/OrganizationApi";
import { useTranslation } from "react-i18next";
import { getImageUrl } from "../Helpers/Helpers";

function EditMenu() {
  const { t } = useTranslation();
  let id = useParams();
  const [currentMenu, setCurrentMenu] = useState(null);

  // Title state
  const [titre, setTitre] = useState({
    fr: "",
    en: "",
    ar: "",
  });

  const [org, setOrg] = useState();

  // Description state
  const [description, setDescription] = useState({
    fr: "",
    en: "",
    ar: "",
  });

  const [ordre, setOrdre] = useState(1);
  const [image, setImage] = useState([]);
  const [categorie, setCategorie] = useState();
  const [selectedCategorie, setSelectedCategorie] = useState(null);
  const [sousCategories, setSousCategories] = useState([]);

  // Price fields
  const [prix_ht, setPrix_ht] = useState("");
  const [prix_ttc, setPrix_ttc] = useState("");
  const [tva, setTva] = useState(0);

  // Stock and inventory
  const [seuilAlerte, setSeuilAlerte] = useState(5);

  // Product identification
  const [reference, setReference] = useState("");
  const [codeBarre, setCodeBarre] = useState("");

  // Measurements
  const [poids, setPoids] = useState("");

  // Product status
  const [dispo, setDispo] = useState(true);
  const [readyToServe, setReadyToServe] = useState(false);

  const [info, setInfo] = useState([]);
  const user = useUser();
  const [infoUser] = useState(user.result);
  const [loading, setLoading] = useState(true);

  const promptForSuccess = () => {
    swal({
      title: "Pouf ! Votre article a été mis à jour",
      icon: "success",
    });
  };

  const [
    organisations,
    setOrganisations,
    usedOrganisations,
    setUsedOrganisations,
  ] = useOrganisations();

  const onSubmit = async (e) => {
    e.preventDefault();

    // 1. Validation logic
    if (!titre.fr || !selectedCategorie) {
      toast.error("S'il-vous-plaît remplissez tous les champs requis!");
      return;
    }

    // 2. Call the service with individual arguments matching the service definition
    try {
      const res = await editMenu(
        titre, // Object: {fr, en, ar}
        description, // Object: {fr, en, ar}
        info, // Array from Repeater
        image, // File list from input
        prix_ht, // String/Number
        prix_ttc, // String/Number
        tva, // Number
        seuilAlerte, // Number
        reference, // String
        codeBarre, // String
        poids, // Number
        dispo, // Boolean
        readyToServe, // Boolean
        ordre, // Number
        id.id, // The Menu ID from params
        usedOrganisations, // The Org ID
        sousCategories, // Array of IDs
        selectedCategorie, // The Main Category ID
      );

      // 3. Handle Response
      if (res && res.data && res.data.success) {
        promptForSuccess();
      } else {
        toast.error("Erreur lors de la mise à jour");
      }
    } catch (error) {
      console.error("Update error:", error);
      toast.error("Une erreur serveur est survenue.");
    }
  };

  useEffect(() => {
    getMenuById(id.id).then((res) => {
      const success = res.data.success;
      if (success === false) {
        toast.error("Erreur lors du chargement");
      } else {
        const menu = res.data.data;
        setCurrentMenu(menu);

        // Set all fields from the menu
        setTitre(menu.titre || { fr: "", en: "", ar: "" });
        setOrdre(menu.ordre || 1);
        setDescription(menu.description || { fr: "", en: "", ar: "" });
        setInfo(menu.info || []);
        setSelectedCategorie(menu.category_id?._id);

        // Price fields
        setPrix_ht(menu.prix_ht || "");
        setPrix_ttc(menu.prix_ttc || "");
        setTva(menu.tva || 0);

        // Stock and inventory
        setSeuilAlerte(menu.seuil_alerte || 5);

        // Product identification
        setReference(menu.reference || "");
        setCodeBarre(menu.code_barre || "");

        // Measurements
        setPoids(menu.poids || "");

        // Product status
        setDispo(menu.dispo !== undefined ? menu.dispo : true);
        setReadyToServe(menu.readyToServe || false);

        // Sous-categories
        setSousCategories(menu.sous_categories || []);
      }
    });

    getCategories(usedOrganisations).then((res) => {
      const success = res.data.success;
      if (success === "0") {
        toast.error("Erreur lors du chargement des catégories");
      } else {
        setCategorie(res.data.data);
        setLoading(false);
      }
    });

    getOrganisationById(usedOrganisations).then((res) => {
      const success = res.data.success;
      if (success === "0") {
        toast.error("Erreur lors du chargement de l'organisation");
      } else {
        setOrg(res.data.data);
        setLoading(false);
      }
    });
  }, [id, usedOrganisations]);

  return (
    <section className="content">
      <GifLoader loading={loading} />
      <div className="row">
        <div className="col-12">
          <div className="box">
            <div className="box-body">
              <form onSubmit={onSubmit}>
                <div className="form-body">
                  <div className="row">
                    <div className="col-md-6">
                      {/* Title Fields */}
                      <div className="form-group">
                        <label className="font-weight-700 font-size-16">
                          {t("Titre")} *
                        </label>
                        {org && org.type === "Restaurant" ? (
                          <>
                            <input
                              value={titre.fr || ""}
                              onChange={(e) =>
                                setTitre({ ...titre, fr: e.target.value })
                              }
                              type="text"
                              className="form-control mb-2"
                              placeholder="Titre (fr)"
                              required
                            />
                            <input
                              value={titre.en || ""}
                              onChange={(e) =>
                                setTitre({ ...titre, en: e.target.value })
                              }
                              type="text"
                              className="form-control mb-2"
                              placeholder="Titre (en)"
                            />
                            <input
                              value={titre.ar || ""}
                              onChange={(e) =>
                                setTitre({ ...titre, ar: e.target.value })
                              }
                              type="text"
                              className="form-control"
                              placeholder="Titre (ar)"
                            />
                          </>
                        ) : (
                          <input
                            value={titre.fr || ""}
                            onChange={(e) =>
                              setTitre({
                                fr: e.target.value,
                                en: e.target.value,
                                ar: e.target.value,
                              })
                            }
                            type="text"
                            className="form-control"
                            placeholder="Titre"
                            required
                          />
                        )}
                      </div>

                      {/* Category Selection */}
                      <div className="form-group">
                        <label
                          className="font-weight-700 font-size-16"
                          onClick={() => console.log(categorie)}
                        >
                          {t("Catégorie")} *
                        </label>
                        <select
                          className="form-control"
                          value={selectedCategorie || ""}
                          onChange={(e) => setSelectedCategorie(e.target.value)}
                          required
                        >
                          <option value="">Sélectionner une catégorie</option>
                          {categorie &&
                            categorie.map((cat) => (
                              <option key={cat._id} value={cat._id}>
                                {cat.libelle?.fr}
                              </option>
                            ))}
                        </select>
                      </div>

                      {/* Price Fields */}
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label className="font-weight-700 font-size-16">
                              {t("Prix HT")}
                            </label>
                            <input
                              value={prix_ht}
                              onChange={(e) => setPrix_ht(e.target.value)}
                              type="number"
                              step="0.001" // Changed from 0.01 to 0.001
                              min="0"
                              className="form-control"
                              placeholder="0.00"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label className="font-weight-700 font-size-16">
                              {t("TVA %")}
                            </label>
                            <input
                              value={tva}
                              onChange={(e) => setTva(e.target.value)}
                              type="number"
                              step="0.001" // Changed from 0.01 to 0.001
                              min="0"
                              max="100"
                              className="form-control"
                              placeholder="0"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label className="font-weight-700 font-size-16">
                              {t("Prix TTC")}
                            </label>
                            <input
                              value={prix_ttc}
                              onChange={(e) => setPrix_ttc(e.target.value)}
                              type="number"
                              step="0.001" // Changed from 0.01 to 0.001
                              min="0"
                              className="form-control"
                              placeholder="0.00"
                            />
                          </div>
                        </div>
                      </div>

                      {/* Product Reference */}
                      <div className="form-group">
                        <label className="font-weight-700 font-size-16">
                          {t("Référence")}
                        </label>
                        <input
                          value={reference}
                          onChange={(e) => setReference(e.target.value)}
                          type="text"
                          className="form-control"
                          placeholder="REF-12345"
                        />
                      </div>

                      {/* Barcode */}
                      <div className="form-group">
                        <label className="font-weight-700 font-size-16">
                          {t("Code barre")}
                        </label>
                        <input
                          value={codeBarre}
                          onChange={(e) => setCodeBarre(e.target.value)}
                          type="text"
                          className="form-control"
                          placeholder="1234567890123"
                        />
                      </div>

                      {/* Weight */}
                      <div className="form-group">
                        <label className="font-weight-700 font-size-16">
                          {t("Poids (kg)")}
                        </label>
                        <input
                          value={poids}
                          onChange={(e) => setPoids(e.target.value)}
                          type="number"
                          step="0.001"
                          min="0"
                          className="form-control"
                          placeholder="0.000"
                        />
                      </div>

                      {/* Alert Threshold */}
                      <div className="form-group">
                        <label className="font-weight-700 font-size-16">
                          {t("Seuil d'alerte")}
                        </label>
                        <input
                          value={seuilAlerte}
                          onChange={(e) => setSeuilAlerte(e.target.value)}
                          type="number"
                          min="0"
                          className="form-control"
                          placeholder="5"
                        />
                      </div>

                      {/* Restaurant specific fields */}
                      {org && org.type === "Restaurant" && (
                        <>
                          <div className="form-group">
                            <label className="font-weight-700 font-size-16">
                              {t("Ordre dans menu")}
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              value={ordre}
                              onChange={(e) => setOrdre(e.target.value)}
                              min="1"
                            />
                          </div>

                          <div className="row">
                            <div className="col-xl-6 col-6 mb-20">
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={dispo}
                                      onChange={(e) =>
                                        setDispo(e.target.checked)
                                      }
                                    />
                                  }
                                  label={t("Disponible")}
                                />
                              </FormGroup>
                            </div>
                            <div className="col-xl-6 col-6 mb-20">
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={readyToServe}
                                      onChange={(e) =>
                                        setReadyToServe(e.target.checked)
                                      }
                                    />
                                  }
                                  label={t("Prêt à servir")}
                                />
                              </FormGroup>
                            </div>
                          </div>
                        </>
                      )}
                    </div>

                    {/* Image Upload Section */}
                    <div className="col-md-6">
                      <h4 className="box-title mt-20">{t("Image")}</h4>
                      <div className="product-img text-left">
                        <img
                          src={
                            image.length
                              ? URL.createObjectURL(image[0])
                              : currentMenu?.image?.length
                                ? getImageUrl(currentMenu.image)
                                : "images/products/no-image.png"
                          }
                          alt=""
                          className="mb-15"
                          style={{ maxWidth: "200px", maxHeight: "200px" }}
                        />
                        <p>{t("Changer l'image")}</p>
                        <div className="btn btn-info mb-20 choose-file">
                          <input
                            type="file"
                            name="image"
                            className="upload"
                            multiple
                            onChange={(e) => setImage(e.target.files)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Description Fields */}
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label className="font-weight-700 font-size-16">
                          {t("Description")}
                        </label>
                        {org && org.type === "Restaurant" ? (
                          <>
                            <textarea
                              value={description.fr || ""}
                              onChange={(e) =>
                                setDescription({
                                  ...description,
                                  fr: e.target.value,
                                })
                              }
                              className="form-control mb-2"
                              placeholder="Description (fr)"
                              rows="3"
                            />
                            <textarea
                              value={description.en || ""}
                              onChange={(e) =>
                                setDescription({
                                  ...description,
                                  en: e.target.value,
                                })
                              }
                              className="form-control mb-2"
                              placeholder="Description (en)"
                              rows="3"
                            />
                            <textarea
                              value={description.ar || ""}
                              onChange={(e) =>
                                setDescription({
                                  ...description,
                                  ar: e.target.value,
                                })
                              }
                              className="form-control"
                              placeholder="Description (ar)"
                              rows="3"
                            />
                          </>
                        ) : (
                          <textarea
                            value={description.fr || ""}
                            onChange={(e) =>
                              setDescription({
                                fr: e.target.value,
                                en: e.target.value,
                                ar: e.target.value,
                              })
                            }
                            className="form-control"
                            placeholder="Description"
                            rows="3"
                          />
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Sous-categories selection if needed */}
                  {categorie && selectedCategorie && (
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label className="font-weight-700 font-size-16">
                            {t("Sous-catégories")}
                          </label>
                          <select
                            className="form-control"
                            multiple
                            value={sousCategories}
                            onChange={(e) =>
                              setSousCategories(
                                Array.from(
                                  e.target.selectedOptions,
                                  (option) => option.value,
                                ),
                              )
                            }
                          >
                            {categorie
                              .filter((cat) => cat._id !== selectedCategorie)
                              .map((cat) => (
                                <option key={cat._id} value={cat._id}>
                                  {cat.nom?.fr || cat.nom}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Ingredients Link for Restaurant */}
                  {org && org.type === "Restaurant" && (
                    <div className="row">
                      <Link
                        to={"/ingredients/" + id.id}
                        className="btn btn-success mt-10 d-block text-center p5"
                        style={{ width: "100%" }}
                      >
                        <span>{t("Ajouter/Modifier Ingrédients")}</span>
                      </Link>
                    </div>
                  )}

                  {/* Repeater for Showroom/Events */}
                  {org &&
                    (org.type === "Showroom" || org.type === "Events") &&
                    currentMenu && (
                      <Repeater onChange={setInfo} defaultValue={info} />
                    )}
                </div>

                {/* Form Actions */}
                <div className="form-actions mt-10">
                  <Link to="/menus">
                    <button type="button" className="btn btn-danger">
                      {t("Annuler")}
                    </button>
                  </Link>
                  <button type="submit" className="btn btn-primary left-button">
                    <i className="fa fa-check"></i> {t("Enregistrer")}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default EditMenu;
